// Power Reviews: Convert rating count span to anchor for products with 0 reviews
(function() {
  let listenerAttached = false;
  
  function linkReviewCount() {
    const span = document.querySelector('.pr-snippet-rating-count');
    // const reviewDisplay = document.querySelector('[data-testid="review-display"]');
    // const anchorId = reviewDisplay?.id || 'pr-reviewdisplay';
    const anchorId = 'pr-reviewdisplay';
    
    // Only convert span to a if it's not already wrapped/linked
    if (span && !span.closest('a')) {
      const a = document.createElement('a');
      a.href = `#${anchorId}`;
      a.className = span.className;
      a.textContent = span.textContent;
      
      Array.from(span.attributes).forEach(attr => {
        if (attr.name.startsWith('data-')) {
          a.setAttribute(attr.name, attr.value);
        }
      });
      
      span.replaceWith(a);
    }
    
    // Only attach listener ONCE per page load
    if (!listenerAttached) {
      const anchor = document.querySelector('a.pr-snippet-rating-count');
      
      if (anchor) {
        anchor.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const target = document.getElementById(anchorId);
          if (target) {
            // Wait for page to settle, then scroll target into view
            setTimeout(() => {
              const target = document.getElementById(anchorId);
              if (target) {
                console.log('Target element found:', target);
                console.log('Calling scrollIntoView()');
                target.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'start'
                });
              } else {
                console.log('Target element NOT found with ID:', anchorId);
              }
            }, 200);
          }
        }, true);
        
        listenerAttached = true;
      }
    }
  }

  // Watch for PR initialization/updates
  const observer = new MutationObserver(() => {
    const reviewSnippet = document.querySelector('#pr-reviewsnippet[data-pr-mounted="true"]');
    if (reviewSnippet) {
      linkReviewCount();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();